import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DRAG_RESIZE_CLASS_NAME = 'DragResize';
export const DRAG_RESIZE_CLASS_SLOTS = ['root', 'content', 'sentinel'] as const;

export type DragResizeClassSlot = (typeof DRAG_RESIZE_CLASS_SLOTS)[number];

export interface DragResizeClasses {
	root: string;
	content: string;
	sentinel: string;

	dragging: string;
	bottom: string;
	left: string;
	right: string;
	top: string;
}

export type DragResizeClassKey = keyof DragResizeClasses;

export const getDragResizeUtilityClass = (slot: string) =>
	generateUtilityClass(DRAG_RESIZE_CLASS_NAME, slot);

export const dragResizeClasses: DragResizeClasses = generateUtilityClasses(
	DRAG_RESIZE_CLASS_NAME,
	['root', 'content', 'dragging', 'left', 'right', 'sentinel', 'top', 'bottom'],
);

export default dragResizeClasses;
